import { render, staticRenderFns } from "./trend-no-fill.vue?vue&type=template&id=1b3a83ff&"
import script from "./trend-no-fill.vue?vue&type=script&lang=js&"
export * from "./trend-no-fill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports